import React from 'react';

import LoginLogo from '@totem/components/logos/LoginLogo';
import SwitchOrganizationsDialog from '@totem/components/userContext/organizationSwitch/loginOrganizationSelector/switchOrganizationDialog';

import '../../login/registration.css';

const SwitchOrganization = () => (
  <div styleName="root-container">
    <div
      styleName="middle-box loginscreen"
      className="animate__animated animate__fadeInDown"
    >
      <div>
        <div styleName="login-header">
          <LoginLogo />
        </div>
      </div>
    </div>
    <SwitchOrganizationsDialog />
  </div>
);

export default SwitchOrganization;
